import * as React from 'react';
export const IcCookies = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM22 11.95c-.16.02-.33.05-.5.05-1.3 0-2.44-.63-3.17-1.59-.27.06-.54.09-.83.09-2.21 0-4-1.79-4-4 0-.43.09-.84.21-1.23A3.993 3.993 0 0112 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10v-.05zM7.5 16c-.83 0-1.5-.67-1.5-1.5S6.67 13 7.5 13s1.5.67 1.5 1.5S8.33 16 7.5 16zm1-5.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM17 17c-.83 0-1.5-.67-1.5-1.5S16.17 14 17 14s1.5.67 1.5 1.5S17.83 17 17 17z'
      fill='currentColor'
    />
  </svg>
);
